import { CalendarDays } from "lucide-react";
import { useBooking } from "@/context/BookingContext";
import { ui } from "@/content";

const variants = {
  primary: "bg-amber text-ink hover:bg-amber-deep shadow-[0_8px_24px_-12px_rgba(180,120,40,0.7)]",
  dark: "bg-forest text-cream hover:bg-pine",
  outline: "border border-current bg-transparent hover:bg-white/10",
};

export default function BookButton({ variant = "primary", size = "md", className = "", testId, label = ui.bookCta, icon = true }) {
  const { openBooking } = useBooking();
  const sizes = size === "lg" ? "h-14 px-8 text-base" : size === "sm" ? "h-10 px-5 text-sm" : "h-12 px-6 text-[15px]";
  return (
    <button
      type="button"
      onClick={openBooking}
      data-testid={testId}
      className={`np-btn inline-flex items-center justify-center gap-2 rounded-full font-semibold ${sizes} ${variants[variant]} ${className}`}
    >
      {icon && <CalendarDays className="h-4 w-4" aria-hidden="true" />}
      {label}
    </button>
  );
}
